import axios from 'axios';
import { BASE_URL } from '../../../api';

const couponHttp = axios.create({
  timeout: 15000,
});

couponHttp.interceptors.request.use(
  (config) => {
    // BASE_URL is read here (request time), not at module load, because api.js
    // imports this file and a top-level read would hit the circular-import TDZ.
    if (!config.baseURL) {
      config.baseURL = `${BASE_URL}/api`;
    }
    const token = localStorage.getItem('token');
    if (!token) {
      const err = new Error('Your session is missing. Please log in again.');
      err.code = 'NO_TOKEN';
      return Promise.reject(err);
    }
    config.headers.Authorization = `Token ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

couponHttp.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default couponHttp;
